/**
 * API-обёртки модуля `jobs` — глобальный индикатор фоновых процессов.
 *
 * Бэкенд: docs/data-model.md §3.10 (таблица jobs), маршруты apps/api/src/modules/jobs/routes.ts.
 */
import { apiRequest } from '../../shared/api/client.ts';
import type { JobResponse, JobListResponse, CancelJobResponse } from '@lens/shared';

/** Список моих job'ов: активные + недавно завершённые (scope='recent') или только активные. */
export async function listJobs(scope: 'active' | 'recent' = 'recent'): Promise<JobListResponse> {
  return apiRequest<JobListResponse>(`/api/jobs?scope=${scope}`);
}

/** Статус одного job'а. */
export async function getJob(jobId: string): Promise<JobResponse> {
  return apiRequest<JobResponse>(`/api/jobs/${jobId}`);
}

/** Отменить pending/running job. */
export async function cancelJob(jobId: string): Promise<CancelJobResponse> {
  return apiRequest<CancelJobResponse>(`/api/jobs/${jobId}/cancel`, { method: 'POST' });
}
